export const TRANSCRIPT_MODE_ORDINARY = 'ordinary';
export const TRANSCRIPT_MODE_LOCKER_SCOPED = 'locker_scoped';
export const TRANSCRIPT_MODE_PENDING = 'pending_server';
export const LOCKER_SCOPED_SAFE_CHAT_TITLE = 'Secure chat';
export const SCOPED_TRANSCRIPT_PROTOCOL_VERSION = 2;

const VALID_SERVER_MODES = new Set([
  TRANSCRIPT_MODE_ORDINARY,
  TRANSCRIPT_MODE_LOCKER_SCOPED,
]);

export class TranscriptPolicyError extends Error {
  constructor(code, message) {
    super(message);
    this.name = 'TranscriptPolicyError';
    this.code = code;
  }
}

export function normalizeServerTranscriptMode(value) {
  return VALID_SERVER_MODES.has(value) ? value : null;
}

export function transcriptModeForChat(chat) {
  if (!chat || !Object.prototype.hasOwnProperty.call(chat, 'transcriptMode')) {
    return TRANSCRIPT_MODE_ORDINARY;
  }
  if (chat.transcriptMode === TRANSCRIPT_MODE_PENDING) {
    return TRANSCRIPT_MODE_PENDING;
  }
  return normalizeServerTranscriptMode(chat.transcriptMode)
    || TRANSCRIPT_MODE_PENDING;
}

export function ownerReadableTranscriptAllowed(chat) {
  return transcriptModeForChat(chat) === TRANSCRIPT_MODE_ORDINARY;
}

export function isLockerScopedTranscript(chat) {
  return transcriptModeForChat(chat) === TRANSCRIPT_MODE_LOCKER_SCOPED;
}

export function isTranscriptPolicyPending(chat) {
  return transcriptModeForChat(chat) === TRANSCRIPT_MODE_PENDING;
}

export function reconcileServerTranscriptMode(chat, serverMode) {
  const priorMode = transcriptModeForChat(chat);
  const nextMode = normalizeServerTranscriptMode(serverMode);

  if (!nextMode) {
    if (
      priorMode === TRANSCRIPT_MODE_LOCKER_SCOPED
      || priorMode === TRANSCRIPT_MODE_PENDING
    ) {
      throw new TranscriptPolicyError(
        'transcript_mode_unavailable',
        'Secure transcript policy could not be verified.'
      );
    }
    return TRANSCRIPT_MODE_ORDINARY;
  }

  if (
    priorMode === TRANSCRIPT_MODE_LOCKER_SCOPED
    && nextMode !== TRANSCRIPT_MODE_LOCKER_SCOPED
  ) {
    throw new TranscriptPolicyError(
      'transcript_scope_downgrade',
      'A scope-bound transcript cannot become owner-readable.'
    );
  }

  return nextMode;
}

export function chatsForOwnerReadablePersistence(chats) {
  if (!Array.isArray(chats)) return [];
  return chats.map((chat) => {
    if (ownerReadableTranscriptAllowed(chat)) return chat;
    return {
      ...chat,
      name: LOCKER_SCOPED_SAFE_CHAT_TITLE,
      title: LOCKER_SCOPED_SAFE_CHAT_TITLE,
      messages: [],
    };
  });
}
